import { BaseClient } from '../BaseClient';
import { ServiceArea, ServiceAreaList } from '../compiled-protos/service_area';
import { ServiceAreaServiceClient } from '../compiled-protos/service_area.client';

class ServiceAreaClient extends BaseClient {
  self: ServiceAreaServiceClient;

  constructor(host: string, userID?: number) {
    super(host, userID);
    this.self = new ServiceAreaServiceClient(this.transport);
  }

  // BatchGet is the only RPC the service exposes -- the boundary is edited by SQL
  // against the service_area row, so there is no Create, Update or Delete.
  // The error is not swallowed: a failed read has to stay distinguishable from
  // "there is no boundary", which is a legitimate answer the callers treat as inert.
  public async BatchGet(req: ServiceArea): Promise<ServiceAreaList> {
    return await this.self.batchGetServiceArea(req, this.getMetaData()).response;
  }
}

export { ServiceArea, ServiceAreaClient, ServiceAreaList };
